import { PropertyType } from '~/client/graph/types.generated'
import { IResourceProperty } from '~/client/src/shared/components/ResourceCardList/types'
import { getResourceLinkTarget } from '~/client/src/shared/resources/resourceLink'

interface IFilterableDynamicResourceProperty {
  propertyType: IResourceProperty['propertyType']
  configuration?: IResourceProperty['configuration']
}

interface INamedFilterableDynamicResourceProperty extends IFilterableDynamicResourceProperty {
  name: IResourceProperty['name']
}

const assertNever = (value: never): never => {
  throw new Error(`Unhandled resource property type: ${String(value)}`)
}

export const isDynamicResourcePropertyFilterable = ({
  propertyType,
  configuration,
}: IFilterableDynamicResourceProperty): boolean => {
  switch (propertyType) {
    case PropertyType.Select:
    case PropertyType.Hierarchy:
    case PropertyType.Checkbox:
    case PropertyType.Number:
      return true
    case PropertyType.Text:
      return !configuration?.multiline
    case PropertyType.Company:
    case PropertyType.User:
      return true
    case PropertyType.ResourceLink:
      return getResourceLinkTarget(configuration)?.isFilterable ?? false
    case PropertyType.Datetime:
    case PropertyType.File:
    case PropertyType.Rollup:
    case PropertyType.ComputedField:
      return false
    default:
      return assertNever(propertyType)
  }
}

export const getDynamicFilterableResourcePropertyNames = (
  properties?: INamedFilterableDynamicResourceProperty[],
): string[] => {
  if (!properties?.length) {
    return []
  }

  return properties
    .filter(property => isDynamicResourcePropertyFilterable(property))
    .map(property => property.name)
}
